export const API_ENDPOINTS = {
  AUTH: {
    GOOGLE_LOGIN: '/auth/google/oauth',
    CHECK_AUTH: '/auth/check',
    LOGOUT: '/auth/logout',
  },
  NOAUTH: {
    DOWNLOAD_HLS_AS_WAV: "/download-share",
    // New endpoint to redeem a share by ID
    REDEEM_SHARE: '/redeem-share',
    // IssueCast capture GET by ID (returns { issueCast, dailyForecast })
    ISSUECAST_BY_ID: '/issuecast',
  },
  PUBLISHER: {
    PUBLISHERS: {
      BASE: '/publisher/publishers',
      LIST: '/publisher/publishers',
      DETAIL: (id: string) => `/publisher/publishers/${encodeURIComponent(id)}`,
      CREATE: '/publisher/publishers',
      WIZARD_CREATE_PODCAST_FROM_RSS: '/publisher/publishers/wizard/create-podcast-from-rss',
      UPDATE: (id: string) => `/publisher/publishers/${encodeURIComponent(id)}`,
      DELETE: (id: string) => `/publisher/publishers/${encodeURIComponent(id)}`,
      FILTER: '/publisher/publishers/filter',
      FULL_PREVIEW: '/publisher/publishers/full-preview',
      SHARE: '/publisher/publishers/share',
      // New IssueCast publish endpoint (matches server route pattern without /api prefix like others)
      // New IssueCasts list endpoint
      // NEW: Pronunciation rules endpoints
      PRONUNCIATION: {
        ENTRIES: (publisherId: string) => `/publisher/publishers/${encodeURIComponent(publisherId)}/pronunciation-rules/entries`,
        ENTRY: (publisherId: string, entryId: string) => `/publisher/publishers/${encodeURIComponent(publisherId)}/pronunciation-rules/entries/${encodeURIComponent(entryId)}`,
        SYNC: (publisherId: string) => `/publisher/publishers/${encodeURIComponent(publisherId)}/pronunciation-rules/sync`,
      },
    },
    ISSUECASTS: {
      LIST: '/publisher/issueCasts/issueCasts',
      PUBLISH_ISSUECAST: '/publisher/issueCasts/publishIssueCast',
      DETAIL: (id: string) => `/publisher/issueCasts/issueCasts/${encodeURIComponent(id)}`,
      // Alternate path per OpenAPI: /api/publisher/publishers/issueCasts/{id}
      DETAIL_BY_PUBLISHERS: (id: string) => `/publisher/publishers/issueCasts/${encodeURIComponent(id)}`,
      UPDATE: (id: string) => `/publisher/issueCasts/issueCasts/${encodeURIComponent(id)}`,
      DELETE: (id: string) => `/publisher/issueCasts/issueCasts/${encodeURIComponent(id)}`,
    },
    WEBSITES: {
      BASE: '/publisher/websites',
      LIST: '/publisher/websites',
      DETAIL: (id: string) => `/publisher/websites/${encodeURIComponent(id)}`,
      CREATE: '/publisher/websites',
      UPDATE: (id: string) => `/publisher/websites/${encodeURIComponent(id)}`,
      DELETE: (id: string) => `/publisher/websites/${encodeURIComponent(id)}`,
      FILTER: '/publisher/websites/filter',
      TEST: '/publisher/websites/test-selectors',
      COLLECT_NOW: `/publisher/websites/collect-now`,
      BY_PUBLISHER: (publisherId: string) => `/publisher/websites/by-publisher/${encodeURIComponent(publisherId)}`,
      AI_SELECTORS: (websiteId: string) => `/publisher/websites/${encodeURIComponent(websiteId)}/ai-selectors`,
      STUDIO: {
        PREVIEW: (websiteId: string) => `/publisher/websites/${encodeURIComponent(websiteId)}/studio/preview`,
        VOICE_SAMPLE: (websiteId: string) => `/publisher/websites/${encodeURIComponent(websiteId)}/studio/voice-sample`,
        CASTING_DIRECTOR: (websiteId: string) => `/publisher/websites/${encodeURIComponent(websiteId)}/studio/casting-director`,
        AI_STYLE: (websiteId: string) => `/publisher/websites/${encodeURIComponent(websiteId)}/studio/ai-style`,
        AI_HOSTS: (websiteId: string) => `/publisher/websites/${encodeURIComponent(websiteId)}/studio/ai-hosts`,
        MUSIC: (websiteId: string) => `/publisher/websites/${encodeURIComponent(websiteId)}/studio/music`,
        AI_EPISODE_DESCRIPTION: (websiteId: string) => `/publisher/websites/${encodeURIComponent(websiteId)}/studio/ai-episode-description`,
      },
    },
    JOURNALISTS: {
      BASE: '/publisher/journalists',
      LIST: '/publisher/journalists',
      DETAIL: (id: string) => `/publisher/journalists/${encodeURIComponent(id)}`,
      CREATE: '/publisher/journalists',
      UPDATE: (id: string) => `/publisher/journalists/${encodeURIComponent(id)}`,
      DELETE: (id: string) => `/publisher/journalists/${encodeURIComponent(id)}`,
      FILTER: '/publisher/journalists/filter',
      BY_PUBLISHER: (publisherId: string) => `/publisher/journalists/by-publisher/${encodeURIComponent(publisherId)}`,
      // Removed legacy multi-publisher assignment endpoints
    },
    ARTICLES: {
      BASE: '/publisher/articles',
      LIST: '/publisher/articles',
      DETAIL: (id: string) => `/publisher/articles/${encodeURIComponent(id)}`,
      CREATE: '/publisher/articles',
      UPDATE: (id: string) => `/publisher/articles/${encodeURIComponent(id)}`,
      DELETE: (id: string) => `/publisher/articles/${encodeURIComponent(id)}`,
      DELETE_BY_FILTER: '/publisher/articles/filter',
      FILTER: '/publisher/articles/filter',
      BY_PUBLISHER: (publisherId: string) => `/publisher/articles/by-publisher/${encodeURIComponent(publisherId)}`,
      BY_WEBSITE: (websiteId: string) => `/publisher/articles/by-website/${encodeURIComponent(websiteId)}`,
      AUTO_WEATHER: '/publisher/articles/auto/weather',
      AUTO_FROM_URL: '/publisher/articles/auto/from-url',
      AUTO_FROM_PDF: '/publisher/articles/auto/from-pdf',
      // NEW: Import articles from RSS feed
      AUTO_FROM_RSS: '/publisher/articles/auto/from-rss',
      // NEW: Multi-source auto generation
      AUTO_MULTISOURCE: '/publisher/articles/auto/multisource',
    },
    LOCATIONS: {
      LIST: '/publisher/locations',
    },
    MEDIA: {
      BASE: '/publisher/media',
      LIST: '/publisher/media',
      DETAIL: (id: string) => `/publisher/media/${encodeURIComponent(id)}`,
      CREATE: '/publisher/media',
      UPDATE: (id: string) => `/publisher/media/${encodeURIComponent(id)}`,
      DELETE: (id: string) => `/publisher/media/${encodeURIComponent(id)}`,
      DOWNLOAD: (id: string) => `/publisher/media/${encodeURIComponent(id)}/download`,
    },
    EVENTS: {
      BASE: '/publisher/events',
      LIST: '/publisher/events',
      DETAIL: (id: string) => `/publisher/events/${encodeURIComponent(id)}`,
      CREATE: '/publisher/events',
      UPDATE: (id: string) => `/publisher/events/${encodeURIComponent(id)}`,
      DELETE: (id: string) => `/publisher/events/${encodeURIComponent(id)}`,
      BY_WEBSITE: (websitePK: string) => `/publisher/events/by-website/${encodeURIComponent(websitePK)}`,
    },
    ANALYTICS: {
      LATEST: '/publisher/websites/analytics/daily/latest',
      DAY: (day: string) => `/publisher/websites/analytics/daily/${encodeURIComponent(day)}`,
      RANGE: '/publisher/websites/analytics/daily/range',
      SUMMARY: '/publisher/websites/analytics/summary',
    },
  },
};
